import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      maxWidth: 466,
      margin: '0 auto',
    },
    content: {
      padding: theme.spacing(2),
      border: '1px solid',
      borderColor: theme.oysterTheme.stone,
      color: theme.oysterTheme.oyster,
    },
    indicator: {
      zIndex: 1,
      backgroundColor: ({ secondaryColor }) => secondaryColor,
    },
    tab: {
      minWidth: 'auto',
      maxWidth: '50%',
      minHeight: 66,
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '109%',
      color: ({ primaryColor }) => primaryColor,
      '&.Mui-selected': {
        color: ({ secondaryColor }) => secondaryColor,
      },
      '& .MuiTab-wrapper': {
        alignItems: 'center',
      },
    },
    backControl: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    backIcon: {
      transform: 'rotate(90deg)',
      cursor: 'pointer',
    },
    speiFormTitle: {
      fontWeight: 'bold',
      fontSize: 24,
      textAlign: 'left',
      marginLeft: theme.spacing(1),
    },
  }),
);

export default useStyles;
